import {Form} from 'antd';
import {Select} from "@/theme";

export const SelectFilter = ({name = 'search', width = 200, ...rest}) => {
    const form = Form.useFormInstance();

    return (
        <>
            <Form.Item
                name={name}
                noStyle
            >
                <Select
                    style={{
                        width,
                    }}
                    allowClear
                    onChange={form.submit}
                    showSearch
                    filterOption={(input, option) =>{
                        const name = rest.fieldNames ? rest.fieldNames.label : 'label'
                        return (option[name] ?? '').toLowerCase().includes(input.toLowerCase())
                    }}
                    {...rest}
                />
            </Form.Item>
        </>
    );
}